/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import ViewMode from "App/view/modes/view_mode";
import RenderDocument from "App/render_document";
import {vec2} from "gl-matrix";
import ViewVR from "App/view/view_vr";
import ViewModeWebVR from "App/view/modes/view_mode_web_vr";
import CameraWebVR from "App/view/cameras/camera_web_vr";

export default
class ViewWebVR extends ViewVR {
    constructor(aViewMode: ViewMode, aDocument: RenderDocument, aPositionPct: vec2, aSizePct: vec2) {
        super(aViewMode, aDocument, aPositionPct, aSizePct);
    }

    public render() {
        this._controls.render();

        super.render();
    }

    protected _renderLeft() {
        this.position = this.positionL;
        this.size = this.sizeL;

        // set camera parameters for left stereo view
        let camera = this._controls.getCamera() as CameraWebVR;

        if (camera instanceof CameraWebVR) {
            camera.setVRDisplay(((this._viewMode) as ViewModeWebVR).getVRDisplay());
            camera.setFrameData(((this._viewMode) as ViewModeWebVR).getFrameData());
            camera.setRenderingLeftView();
        }

        camera._invalidateViewMatrix();
        camera._invalidatePerspectiveProjMatrix();

        this.document.render(this);
    }

    protected _renderRight() {
        this.position = this.positionR;
        this.size = this.sizeR;

        // set camera parameters for right stereo view
        let camera = this._controls.getCamera() as CameraWebVR;

        if (camera instanceof CameraWebVR) {
            camera.setVRDisplay(((this._viewMode) as ViewModeWebVR).getVRDisplay());
            camera.setFrameData(((this._viewMode) as ViewModeWebVR).getFrameData());
            camera.setRenderingRightView();
        }

        camera._invalidateViewMatrix();
        camera._invalidatePerspectiveProjMatrix();

        this.document.render(this);
    }
}
